var TscButtonLabelAlignment = {
  left: 'start',
  center: 'center',
  right: 'end'
};
export default TscButtonLabelAlignment;